import axios from "axios";
import React, { useState, useContext, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { BACKEND_URL } from "../../config/config";
import { NotificationContext } from "../context/NotificationWrapper";
import { Result } from "antd";
import { Spin } from "antd";

function RegisterConfirmation(props) {
  const backendUrl = BACKEND_URL;
  const navigate = useNavigate();
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const { openNotification } = useContext(NotificationContext);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  // useRef pour maintenir un flag à travers les rendus
  const requestSentRef = useRef(false);

  useEffect(() => {
    const verifyEmail = async () => {
      // Vérifiez si la requête a déjà été envoyée
      if (requestSentRef.current) {
        return;
      }
      
      requestSentRef.current = true;
      
      try {
        const headers = {
          "Content-Type": "application/json",
          Accept: "application/json",
        };
        
        const url = props?.isChangeEmail === true
          ? `${backendUrl}/api/register/verify/change/email${location.search}`
          : `${backendUrl}/api/register/verify/email${location.search}`;
        
        await axios.get(url, {
          withCredentials: true,
          headers: headers,
        });
        
        setSuccess(true);
        
        if (props?.isChangeEmail === true) {
          openNotification("Succès", "Adresse vérifiée", "success");
          setTimeout(() => {
            navigate("/infoIdentifier");
          }, 1500);
        } else {
          openNotification("Succès", "Inscription terminée", "success");
          setTimeout(() => {
            navigate("/");
          }, 1500);
        }
      } catch (error) {
        console.error("error", error);
        setError(true);
        openNotification(
          "Erreur",
          "Une erreur est survenue, veuillez réessayer",
          "error"
        );
      } finally {
        setIsLoading(false);
      }
    };
    
    verifyEmail();
    
    // Fonction de nettoyage pour éviter des mises à jour sur des composants démontés
    return () => {
      // Si jamais on navigue ailleurs avant que la requête ne soit terminée
      requestSentRef.current = true;
    };
  }, []);

  return (
    <>
      <div className="form-auth" style={{ width: "100%" }}>
        <div
          className="form-container"
          style={{ alignItems: "center", width: "80%", padding: "40px 20px" }}
        >
          <h2>Vérification de l'adresse e-mail</h2>

          <Spin spinning={isLoading} fullscreen />
          {error && (
            <Result
              status="error"
              title="Une erreur est survenue"
              subTitle="La validation de l'e-mail n'a pas fonctionné."
            />
          )}
          {success && <Result status="success" title="E-mail validé" />}
        </div>
      </div>
    </>
  );
}

export default RegisterConfirmation;
